import { type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'

import { type UpdateShipmentOrderHistoryRequest } from '../../api'

import { ShipmentOrderHistoryFormModalContent } from './ShipmentOrderHistoryUpdateModalContent'

type Props = {
  tenantKey: string
  open: boolean
  updateRequest: UpdateShipmentOrderHistoryRequest | null
  onSuccess: (historyId: number) => void
  onClose: () => void
}

export const ShipmentOrderHistoryUpdateModal: FC<Props> = ({
  tenantKey,
  updateRequest,
  open,
  onSuccess,
  onClose
}) => {
  if (!updateRequest) return null

  return (
    <Modal
      title={MENU.EDITING_HISTORY_NAME}
      width={600}
      open={open}
      onCancel={onClose}
    >
      <ShipmentOrderHistoryFormModalContent
        tenantKey={tenantKey}
        updateRequest={updateRequest}
        onSuccess={onSuccess}
        onClose={onClose}
      />
    </Modal>
  )
}
